import React from 'react'
import cx from 'classnames'
import {SingleLineEditor} from 'common/SingleLineEditor'
import styles from './MastheadEditor.scss'
import appStyles from '../../App/appStyles.scss'

// Single-line, plaintext editor that wraps draft-js
export const MastheadEditor = ({title, subtitle, onChange}) => {
  return (
    <div className={cx(styles.MastheadEditor, appStyles.base, appStyles.reportContainer)}>
      <div className={appStyles.title}>
        <SingleLineEditor
          defaultValue={title}
          placeholder='Write a title for your report'
          textAlignment='center'
          onChange={(title) => onChange({title})} />
      </div>
      <div className={appStyles.subtitle}>
        <SingleLineEditor
          defaultValue={subtitle}
          placeholder='Write a sub-title for your report'
          textAlignment='center'
          onChange={(subtitle) => onChange({subtitle})} />
      </div>
    </div>
  )
}
